import type { SvgIconComponent } from "@mui/icons-material";
import AccountBalance from "@mui/icons-material/AccountBalance";
import SmartToy from "@mui/icons-material/SmartToy";
import Storefront from "@mui/icons-material/Storefront";
import Science from "@mui/icons-material/Science";
import FormatListBulleted from "@mui/icons-material/FormatListBulleted";
import PersonRounded from "@mui/icons-material/PersonRounded";

export interface NavItem {
  label: string;
  description: string;   // tooltip copy
  path: string;
  icon: SvgIconComponent;
  desktop: boolean;      // show in desktop side rail?
  mobile: boolean;       // show in mobile bottom nav?
}

export const NAV_ITEMS: NavItem[] = [
  {
    label: "Accounts",
    description: "Your broker accounts and total portfolio value.",
    path: "/accounts",
    icon: AccountBalance,
    desktop: true,
    mobile: true
  },
  {
    label: "Bots",
    description: "Build, manage, and monitor your trading bots.",
    path: "/bots",
    icon: SmartToy,
    desktop: true,
    mobile: true
  },
  {
    label: "Marketplace",
    description: "Browse and buy pre-built strategy templates.",
    path: "/marketplace",
    icon: Storefront,
    desktop: true,
    mobile: true
  },
  {
    label: "Testing",
    description: "Backtest sessions and historical performance.",
    path: "/testing",
    icon: Science,
    desktop: true,
    mobile: false
  },
  {
    label: "Lists",
    description: "Manage stock symbol lists used by your bots.",
    path: "/lists",
    icon: FormatListBulleted,
    desktop: true,
    mobile: false
  },
  {
    label: "Profile",
    description: "Account settings, theme, and support.",
    path: "/profile",
    icon: PersonRounded,
    desktop: false,         // accessed via top-right avatar on desktop
    mobile: true
  }
];

export const DESKTOP_ITEMS = NAV_ITEMS.filter((n) => n.desktop);
export const MOBILE_TABS   = NAV_ITEMS.filter((n) => n.mobile).slice(0, 5);
